export default {
    desktop: {
        id: "desktop",
        label: "Desktop",
    },
    tablet: {
        id: "tablet",
        label: "Tablet",
    },
    phone: {
        id: "phone",
        label: "Phone",
    },
};

export const icons = {
    "device.desktop": "desktop_mac",
    "device.tablet": "tablet_mac",
    "device.phone": "phone_iphone",
    "device.all": "devices",
    "device.phone-tablet": "desktop_access_disabled",
    "device.tablet-desktop": "mobile_off",
};

export const breakpointClasses = {
    1: "show-desktop",
    2: "show-phone",
    3: "show-tablet-phone",
    4: "show-tablet",
};

export const breakpoints = {
    1: { id: 1, label: "Desktop", icon: "mui-desktop_mac" },
    2: { id: 2, label: "Phone", icon: "mui-phone_iphone" },
    3: { id: 3, label: "Tablet & Phone", icon: "mui-desktop_access_disabled" },
    4: { id: 4, label: "Tablet & Desktop", icon: "mui-mobile_off" },
};

const TARGET_DEVICES = {
    DEFAULT: null,
    ALL: 0,
    DESKTOP: 1,
    MOBILE: 2, // tablet or phone
    PHONE: 3,
    TABLET: 4,
    TABLET_DESKTOP: 5,
};

export const targetDevices = {
    [TARGET_DEVICES.ALL]: "All",
    [TARGET_DEVICES.DESKTOP]: "Desktop",
    [TARGET_DEVICES.MOBILE]: "Mobile",
    [TARGET_DEVICES.PHONE]: "Phone",
    [TARGET_DEVICES.TABLET]: "Tablet",
    [TARGET_DEVICES.TABLET_DESKTOP]: "Tablet & Desktop",
};
